import React from "react"
import { styled } from "@mui/material/styles"
import { Avatar, Badge, ListItemButton, ListItemText } from "@mui/material"
import { timeAgoInWords } from "../utils/stringUtils"
import { editUploadedV2Url } from "../utils/samplefocusDefaults"

const NotificationListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "isUnread",
})(({ isUnread }) => ({
  borderBottom: "0.3px solid #c6c6c6",
  margin: 0,
  "&:hover": {
    backgroundColor: "#ffffff",
  },
  backgroundColor: isUnread ? "#f0f0f0" : "transparent",
}))

const NotificationListItemText = styled(ListItemText)`
  padding: 0 7px 0 7px;
  margin: 0 4px 0 4px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  & .MuiListItemText-primary {
    text-align: left;
    line-height: 1;
  }
  & .MuiListItemText-secondary {
    text-align: left;
  }
`

const NotificationText = styled("div")`
  font-size: 13px;
  padding-top: 5px;
`

const NotificationRowContainer = styled("div")`
  .badge-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }

  .comment-icon {
    color: #017bfe;
  }

  .favorite-icon {
    color: #e2264d;
  }

  .reject-icon {
    color: #ee534f;
  }

  .default-icon {
    color: #9e9e9e;
  }

  .publish-icon {
    color: #80cbc4;
  }

  .request-info-icon {
    color: #64b5f6;
  }
`

export default class NotificationRow extends React.Component {
  render() {
    const { notification, currentUser } = this.props
    const isUnread = notification.read_at === null

    const iconClasses = {
      "comment.create": "fas fa-comments comment-icon",
      "comment.reply": "fas fa-comments comment-icon",
      "favorite.create": "fas fa-heart favorite-icon",
      "collection.publish": "fas fa-check publish-icon",
      "sample.batch_publish": "fas fa-check publish-icon",
      "sample.batch_needs_more_info": "fas fa-question request-info-icon",
      "sample.batch_reject": "fas fa-xmark reject-icon",
    }

    const notificationURLs = {
      "comment.create": `${notification.notification_url}?commentId=${notification.trackable_id}`,
      "comment.reply": `${notification.notification_url}?commentId=${notification.trackable_id}`,
      "favorite.create": notification.notification_url,
      "collection.publish": notification.notification_url,
      "sample.batch_publish": `/users/${currentUser.slug}`,
      "sample.batch_needs_more_info": editUploadedV2Url,
      "sample.batch_reject": `/users/${currentUser.slug}`,
    }

    const iconClass = iconClasses[notification.notification_type] || "fas fa-bell default-icon"
    const notificationURL = notificationURLs[notification.notification_type] || notification.notification_url

    return (
      <NotificationRowContainer>
        <NotificationListItemButton
          href={notificationURL}
          key={notification.id}
          isUnread={isUnread}
        >
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={<span className={`badge-icon ${iconClass}`}></span>}
          >
            <Avatar src={notification.notifier_avatar} />
          </Badge>
          <NotificationListItemText
            primary={
              <NotificationText>
                <strong>{notification.notifier_display_name}{" "}</strong>
                {notification.message}
              </NotificationText>
            }
            secondary={timeAgoInWords(notification.created_at)}
          />
        </NotificationListItemButton>
      </NotificationRowContainer>
    )
  }
}
